import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  KPI_PANEL_IMPORTS,
  KpiPanelComponent,
} from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-total-gas-co2-used-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class TotalGasCo2UsedKpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.TotalGasCo2UsedKpi;
  public override title = `Gas ${DisplayUnit.Co2} uitstoot`;
  public override icon = 'bi-cloudy-fill';
  public override unit = DisplayUnit.Kg;
  public override color = Color.Orange;
}
